import { ACESSOS } from "../../../../Routes/Acessos";
import {
    ListarCategoriasAtendimentoService,
    ListarCategoriasAtendimentosFilhoService,
    ListarCategoriasAtendimentosPaiService,
} from "../../../../Services/Geral/GestaoDeCadastros/CategoriaAtendimento/CategoriaAtendimentoServices";
import { Controller } from "../../../Controller";

export async function ListarCategoriasAtendimentosPaiController() {
    return Controller(ListarCategoriasAtendimentosPaiService());
}

export async function ListarCategoriasAtendimentosFilhoController(
    idCategoriaPai: number
) {
    return Controller(ListarCategoriasAtendimentosFilhoService(idCategoriaPai));
}

export async function ListarCategoriasAtendimentosController(
    idTipoCaso: number
) {
    return Controller(ListarCategoriasAtendimentoService(idTipoCaso));
}

export const ListarCategoriaAtendimentoAoClienteController = async () =>
    ListarCategoriasAtendimentosController(ACESSOS.ATENDIMENTO.ID_MODULO);

export const ListarCategoriaRepasseController = async () =>
    ListarCategoriasAtendimentosController(ACESSOS.REPASSE.ID_MODULO);
